import _mixin from '../_mixin'

export default {
  name: 'SVersionLottery',
  cnName: '抽奖按钮类',
  type: 'activity_version',
  preview: 'https://rescdn-crash.ssjj.cn/website/2023/03/30/dc3e42f445c1787417e8e090fd2b9591.jpeg',
  // 属性相关
  props: {
    defaultBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/13/26848eb593afba1634123fa194db14bb.jpg',
      style: {
        width: '1920px',
        height: '1542px'
      }
    },
    activityId: '7L2E7R27IK2ROJGFYC5Y7HTADI',
    lotteryCount: '1',
    btnLottery: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/03/12/16bdcd38e3dae203e1304aff388ed364.png',
      style: {
        width: '360px',
        height: '128px',
        position: 'absolute',
        top: '515px',
        right: '',
        bottom: '',
        left: '910px'
      }
    },
    showLimit: false,
    showList: [
      {
        id: '1',
        top: '100px',
        left: '100px',
        color: '#000',
        fontSize: '16px'
      }
    ]
  },
  propsDesc: [
    {
      target: 'defaultBg',
      label: '底图',
      formType: 'image'
    },
    {
      target: 'activityId',
      label: '抽奖活动的Id'
    },
    {
      target: 'lotteryCount',
      label: '抽几次'
    },
    {
      target: 'btnLottery',
      label: '抽奖按钮图片',
      formType: 'image'
    },
    {
      target: 'showLimit',
      label: '是否显示余量',
      formType: 'switch'
    },
    {
      target: 'showList',
      label: '显示列表',
      formType: 'list',
      listConfig: [
        {
          title: '礼包id',
          target: 'id'
        },
        {
          title: '礼包top',
          target: 'top'
        },
        {
          title: '礼包left',
          target: 'left'
        },
        {
          title: 'color',
          target: 'color'
        },
        {
          title: 'fontSize',
          target: 'fontSize'
        }
      ]
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ]
}
